import { formatPrice } from "@jti/format-price";
export const getFormattedPriceForQuantity = (finalPrices, quantity) => {
    const finalPrice = finalPrices.find((finalPrice) => finalPrice.multiplier === quantity);
    if (!finalPrice?.currency || !finalPrice?.value)
        return undefined;
    const price = {
        currency: finalPrice.currency,
        value: finalPrice.value,
    };
    return formatPrice(price);
};
//# sourceMappingURL=getFormattedPriceForQuantity.js.map